import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'aeg-button',
  templateUrl: './aeg-button.html',
  styleUrls: ['./aeg-button.scss']
})
export class AegButtonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
